import { useReactiveVar } from "@apollo/client";
import { ApolloStateDispatch } from "helpers/apollo-state-dispatch";
import { IApolloDispatch } from "interfaces/IApolloDispatch";
import { useMemo } from "react";
import {
  INucleofectionInternalState,
  NucleofectionInternalState,
} from "./initial-state";
import { NucleofectionInternalReducer } from "./reducer";

export function useNucleofectionStateProvider(): {
  nucleofectionInternalState: INucleofectionInternalState;
  nucleofectionDispatch: IApolloDispatch<any>;
} {
  const nucleofectionInternalState = useReactiveVar(NucleofectionInternalState);
  const nucleofectionDispatch = useMemo(
    () =>
      ApolloStateDispatch(
        NucleofectionInternalState,
        NucleofectionInternalReducer
      ),
    []
  );
  return {
    nucleofectionInternalState,
    nucleofectionDispatch,
  };
}
